/**
 * Date range utility functions using lexicographic string comparison
 * to avoid timezone-sensitive Date parsing issues with YYYY-MM-DD strings
 */

/**
 * Check if date range includes August 2025
 * Uses string comparison to avoid Date parsing pitfalls
 * @param startDate - Start date in YYYY-MM-DD format
 * @param endDate - End date in YYYY-MM-DD format
 * @returns true if the date range overlaps with August 2025
 */
export const includesAugust2025 = (startDate: string, endDate: string): boolean => {
  // Check if the date ranges overlap using lexicographic string comparison
  // Range overlaps if: start <= august_end && end >= august_start
  return startDate <= '2025-08-31' && endDate >= '2025-08-01';
};

/**
 * Generic function to check if two date ranges overlap
 * @param range1Start - Start of first range (YYYY-MM-DD)
 * @param range1End - End of first range (YYYY-MM-DD)
 * @param range2Start - Start of second range (YYYY-MM-DD)
 * @param range2End - End of second range (YYYY-MM-DD)
 * @returns true if the ranges overlap
 */
export const rangesOverlap = (
  range1Start: string,
  range1End: string,
  range2Start: string,
  range2End: string
): boolean => {
  return range1Start <= range2End && range1End >= range2Start;
};